export default {
    MAINTENANCEREQUESTS: 'MAINTENANCEREQUESTS',
    DELETEMAINTENANCEREQUEST: 'DELETEMAINTENANCEREQUEST'
}